// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3PYln","col":"styles_col__33hfP"};